import "./assets/Pokedex.css"
import TypeFilter from "./TypeFilter";
import FilterDisplay from "./FilterDisplay";
import PokemonDetails from "./PokemonDetails";
import {Route, Link} from "react-router-dom";
import Pokeball from "./assets/pokeball.png"

const Pokedex = () => { 
    let pokemons = [
        {
            name: "Bulbasaur",
            ntnlnum: "#001",
            img: "https://img.pokemondb.net/artwork/vector/large/bulbasaur.png",
            types: ["Grass", "Poison"],
            description: 'There is a plant seed on its back right from the day this Pokémon is born. The seed slowly grows larger.'
        },
        {
            name: "Ivysaur",
            ntnlnum: "#002",
            img: "https://img.pokemondb.net/artwork/vector/large/ivysaur.png",
            types: ["Grass", "Poison"],
            description: 'When the bulb on its back grows large, it appears to lose the ability to stand on its hind legs.'
        },
        {
            name: "Venusaur",
            ntnlnum: "#003",
            img: "https://img.pokemondb.net/artwork/vector/large/venusaur.png",
            types: ["Grass", "Poison"],
            description: 'Its plant blooms when it is absorbing solar energy. It stays on the move to seek sunlight.'
        },
        {
            name: "Charmander",
            ntnlnum: "#004",
            img: "https://img.pokemondb.net/artwork/vector/large/charmander.png",
            types: ["Fire"],
            description: 'It has a preference for hot things. When it rains, steam is said to spout from the tip of its tail.'
        },
        {
            name: "Charmeleon",
            ntnlnum: "#005",
            img: "https://img.pokemondb.net/artwork/vector/large/charmeleon.png",
            types: ["Fire"],
            description: 'It has a barbaric nature. In battle, it whips its fiery tail around and slashes away with sharp claws.'
        },
        {
            name: "Charizard",
            ntnlnum: "#006",
            img: "https://img.pokemondb.net/artwork/vector/large/charizard.png",
            types: ["Fire", "Flying"],
            description: 'It spits fire that is hot enough to melt boulders. It may cause forest fires by blowing flames.'
        },
        {
            name: "Squirtle",
            ntnlnum: "#007",
            img: "https://img.pokemondb.net/artwork/vector/large/squirtle.png",
            types: ["Water"],
            description: 'When it retracts its long neck into its shell, it squirts out water with vigorous force.'
        },
        {
            name: "Caterpie",
            ntnlnum: "#010",
            img: "https://img.pokemondb.net/artwork/vector/large/caterpie.png",
            types: ["Bug"],
            description: 'For protection, it releases a horrible stench from the antenna on its head to drive away enemies.'
        },
        {
            name: "Pidgey",
            ntnlnum: "#016",
            img: "https://img.pokemondb.net/artwork/vector/large/pidgey.png",
            types: ["Normal", "Flying"],
            description: 'Very docile. If attacked, it will often kick up sand to protect itself rather than fight back.'
        },
        {
            name: "Pidgeotto",
            ntnlnum: "#017",
            img: "https://assets.pokemon.com/assets/cms2/img/pokedex/full/017.png",
            types: ["Normal", "Flying"],
            description: 'This Pokémon is full of vitality. It constantly flies around its large territory in search of prey.'
        },
        {
            name: "Pidgeot",
            ntnlnum: "#018",
            img: "https://assets.pokemon.com/assets/cms2/img/pokedex/full/018.png",
            types: ["Normal", "Flying"],
            description: 'This Pokémon flies at Mach 2 speed, seeking prey. Its large talons are feared as wicked weapons.'
        },
        {
            name: "Rattata",
            ntnlnum: "#019",
            img: "https://img.pokemondb.net/artwork/vector/large/rattata.png",
            types: ["Normal"],
            description: 'Will chew on anything with its fangs. If you see one, you can be certain that 40 more live in the area.'
        },
        {
            name: "Arbok",
            ntnlnum: "#024",
            img: "https://img.pokemondb.net/artwork/vector/large/arbok.png",
            types: ["Poison"],
            description: 'The frightening patterns on its belly have been studied. Six variations have been confirmed.'
        },
        {
            name: "Pikachu",
            ntnlnum: "#025",
            img: "https://img.pokemondb.net/artwork/vector/large/pikachu-alt2.png",
            types: ["Electric"],
            description: 'Pikachu that can generate powerful electricity have cheek sacs that are extra soft and super stretchy.'
        },
        {
            name: "Sandshrew",
            ntnlnum: "#027",
            img: "https://img.pokemondb.net/artwork/vector/large/sandshrew.png",
            types: ["Ground"],
            description: 'It loves to bathe in the grit of dry, sandy areas. By sand bathing, the Pokémon rids itself of dirt and moisture clinging to its body.'
        },
        {
            name: "Mankey",
            ntnlnum: "#056",
            img: "https://img.pokemondb.net/artwork/vector/large/mankey.png",
            types: ["Fighting"],
            description: 'An agile Pokémon that lives in trees. It angers easily and will not hesitate to attack anything.'
        },
        {
            name: "Poliwrath",
            ntnlnum: "#062",
            img: "https://img.pokemondb.net/artwork/vector/large/poliwrath.png",
            types: ["Water", "Fighting"],
            description: 'Its body is solid muscle. When swimming through cold seas, Poliwrath uses its impressive arms to smash through drift ice and plow forward.'
        },
        {
            name: "Geodude",
            ntnlnum: "#074",
            img: "https://img.pokemondb.net/artwork/vector/large/geodude.png",
            types: ["Rock", "Ground"],
            description: 'Commonly found near mountain trails and the like. If you step on one by accident, it gets angry.'
        },
        {
            name: "Magnemite",
            ntnlnum: "#081",
            img: "https://img.pokemondb.net/artwork/vector/large/magnemite.png",
            types: ["Electric", "Steel"],
            description: 'At times, Magnemite runs out of electricity and ends up on the ground. If you give batteries to a grounded Magnemite, it’ll start moving again.'
        },
        {
            name: "Cloyster",
            ntnlnum: "#091",
            img: "https://img.pokemondb.net/artwork/vector/large/cloyster.png",
            types: ["Water", "Ice"],
            description: 'Its shell is extremely hard. It cannot be shattered, even with a bomb. The shell opens only when it is attacking.'
        },
        {
            name: "Scyther",
            ntnlnum: "#123",
            img: "https://img.pokemondb.net/artwork/vector/large/scyther.png",
            types: ["Bug", "Flying"],
            description: 'As Scyther fights more and more battles, its scythes become sharper and sharper. With a single slice, Scyther can fell a massive tree.'
        },
        {
            name: "Omanyte",
            ntnlnum: "#138",
            img: "https://img.pokemondb.net/artwork/vector/large/omanyte.png",
            types: ["Rock", "Water"],
            description: 'Because some Omanyte manage to escape after being restored or are released into the wild by people, this species is becoming a problem.'
        },
        {
            name: "Aerodactyl",
            ntnlnum: "#142",
            img: "https://img.pokemondb.net/artwork/vector/large/aerodactyl.png",
            types: ["Flying"],
            description: 'This is a ferocious Pokémon from ancient times. Apparently even modern technology is incapable of producing a perfectly restored specimen.'
        },
        {
            name: "Articuno",
            ntnlnum: "#144",
            img: "https://img.pokemondb.net/artwork/vector/large/articuno.png",
            types: ["Ice", "Flying"],
            description: 'It’s said that this Pokémon’s beautiful blue wings are made of ice. Articuno flies over snowy mountains, its long tail fluttering along behind it.'
        },
        {
            name: "Forretress",
            ntnlnum: "#205",
            img: "https://img.pokemondb.net/artwork/vector/large/forretress.png",
            types: ["Bug", "Steel"],
            description: 'When something approaches it, it fires off fragments of its steel shell in attack. This is not a conscious action but a conditioned reflex.'
        },
    ]
    let types = [
        "All",
        "Normal",
        "Fire",
        "Water",
        "Electric",
        "Grass",
        "Ice",
        "Fighting",
        "Poison",
        "Ground",
        "Flying",
        "Bug",
        "Rock",
        "Steel"
    ]
    return(
        <div className="main-box">
            <Link to="/pokedex/all">
                <div className="logo-div">
                    <img src={Pokeball} alt="pokeball" />
                    <div>
                        <img src="https://logos-world.net/wp-content/uploads/2020/05/Pokemon-Logo.png" alt="pokemon logo"/>
                    </div>
                </div>
            </Link>
            <TypeFilter 
                types = {types}
                pokemons = {pokemons}
            />
            <div className="display-box">
                <FilterDisplay
                    types = {types}
                    pokemons = {pokemons}
                />
                {
                    pokemons.map((pokemon) => 
                        <Route
                            path = {`/pokedex/`+pokemon.name}
                            key={pokemon.name}
                        >
                            <PokemonDetails
                                key = {pokemon.name}
                                pokemon = {pokemon}
                                type = {null}
                            />
                        </Route>
                    )
                }
            </div>
            <div className="sources">
                Icons made by <a href="https://www.flaticon.com/authors/those-icons" title="Those Icons"> Those Icons</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a>
            </div>
        </div>
    )
}

export default Pokedex